import { ClientBrandingConfig } from '../../types/clientConfig';
import { CLIENTS } from '../types';
import { configIcons } from '@/assets/icons';

/**
 * JazzX Client Configuration
 */
const jazzxConfig: ClientBrandingConfig = {
  clientId: CLIENTS.JAZZX,
  clientName: 'JazzX Financial',
  logoSrc: configIcons.jazzxLogo,
  logoAlt: 'JazzX Financial Logo',
  faviconSrc: configIcons.jazzxLogo,
  headerBgColor: '#7c3aed',
  headerTextColor: '#ffffff',
  footerBgColor: '#1f2937',
  footerTextColor: '#d1d5db',
  footerCopyright: '© 2025 JazzX Financial Corporation. All rights reserved.',
  minAge: 18,
  maxAge: 99,
};

export default jazzxConfig;
